import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';

/**
 * Resolve the project the IND module should act on, the same way SAPEditor does:
 * the loaded ProjectContext project wins, else `?project=` / `?projectId=` from
 * the URL (StudyFormTabs uses `project`, the SAP/ICF editor routes use `projectId`).
 * When the URL names a project that is not the loaded one, load it once.
 */
export default function useIndProjectId() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const projectIdFromUrl = params.get('project') || params.get('projectId') || null;
  const { currentProject, loading: projectLoading, error: projectError, loadProject } = useProject();
  const requestedRef = useRef(null);

  useEffect(() => {
    if (!projectIdFromUrl || projectLoading) return;
    if (currentProject && currentProject._id === projectIdFromUrl) return;
    // One load attempt per URL project id, so a failing load cannot loop.
    if (requestedRef.current === projectIdFromUrl) return;
    requestedRef.current = projectIdFromUrl;
    loadProject(projectIdFromUrl);
  }, [projectIdFromUrl, projectLoading, currentProject, loadProject]);

  return {
    projectId: currentProject?._id || projectIdFromUrl,
    projectIdFromUrl,
    projectLoading,
    projectError,
  };
}
